<div class="flex flex-column gap-2" style="padding: 10px" *ngIf="canRequest">
    <p class="m-0">Diagnostic logs</p>

    <div class="flex flex-row flex-wrap align-items-center gap-3">
        <ng-container *ngIf="forDriver">
            <div class="flex flex-row align-items-center gap-2" *ngFor="let option of appOptions">
                <p-checkbox [value]="option.value"
                            [label]="option.label"
                            name="sendLogsAppTypes"
                            [(ngModel)]="selectedAppTypes">
                </p-checkbox>
                <span class="text-sm text-color-secondary">({{ getStatusText(option.value) }})</span>
            </div>
        </ng-container>

        <span *ngIf="!forDriver" class="text-sm text-color-secondary">{{ getStatusText(everyDayApp) }}</span>

        <button pButton pRipple type="button" class="p-button-primary"
                label="Request logs"
                [disabled]="loading || (forDriver && !selectedAppTypes.length)"
                (click)="requestLogs()">
        </button>
    </div>
</div>
